export const enum ActivityLogEvent {
	BOARD_VIEW = 1000,
	BOARD_LOOP_VIEW = 1001,
	REPORT_VIEW = 1002,
	BOARD_CREATED = 1030,
	BOARD_PERMISSIONS_CHANGED = 1031,
	BOARD_TEMPLATE_CREATED = 1032,
	BOARD_TEMPLATE_DELETED = 1033,
	BOARD_EDITED = 1035,
	BOARD_DELETED = 1036,
	BOARD_LINK_SETTINGS_CHANGED = 1037,
	BOARD_SHARED_EMAIL = 1038,
	BOARD_SHARED_SLACK = 1039,
	BOARD_SCHEDULED_SNAPSHOT = 1040,
	BOARD_LINK_SHARED = 1041,
	BOARD_STREAMING_STARTED = 1042,
	BOARD_DOWNLOADED = 1043,
	BOARD_RENAMED = 1044,
	BOARD_VISUALS_EDITED = 1045,
	BOARD_DATABLOCK_ADDED = 1046,
	BOARD_SHARED_TO_CLIENT = 1052,
	BOARD_SHARED_TO_AGENCY = 1053,
	BOARD_OWNER_CHANGED = 1055,
	BOARD_LOOP_CREATED = 1056,
	BOARD_LOOP_EDITED = 1059,
	BOARD_LOOP_OWNER_CHANGED = 1061,
	BOARD_LOOP_SCHEDULED_SNAPSHOT = 1064,
	BOARD_LOOP_DELETED = 1065,
	BOARD_LOOP_LINK_SETTINGS_CHANGED = 1066,
	BOARD_LOOP_LINK_SHARED = 1067,
	BOARD_LOOP_SHARED_EMAIL = 1068,
	BOARD_LOOP_SHARED_SLACK = 1069,
	METRIC_CUSTOM_QUERY_CREATED = 1071,
	METRIC_CALCULATION_CREATED = 1072,
	METRIC_CUSTOM_QUERY_DELETED = 1073,
	METRIC_CUSTOM_QUERY_EDITED = 1075,
	METRIC_CALCULATION_EDITED = 1076,
	METRIC_CUSTOM_QUERY_RENAMED = 1077,
	METRIC_CALCULATION_DELETED = 1078,
	METRIC_DIGEST_CREATED = 1079,
	METRIC_CALCULATION_RENAMED = 1081,
	REPORT_CREATED = 1082,
	REPORT_TEMPLATE_CREATED = 1083,
	REPORT_TEMPLATE_DELETED = 1084,
	REPORT_DELETED = 1085,
	REPORT_DOWNLOADED = 1086,
	REPORT_SHARED_EMAIL = 1087,
	REPORT_SHARED_SLACK = 1088,
	REPORT_SCHEDULED_SNAPSHOT = 1090,
	REPORT_EDITED = 1091,
	REPORT_SLIDE_ADDED = 1096,
	REPORT_OWNER_CHANGED = 1099,
	GOAL_CREATED = 1109,
	GOAL_RENAMED = 1110,
	GOAL_EDITED = 1111,
	GOAL_OWNER_CHANGED = 1114,
	GOAL_DELETED = 1115,
	SCORECARD_CREATED = 1116,
	SCORECARD_RECIPIENTS_CHANGED = 1124,
	SCORECARD_DELETED = 1126,
	ALERT_CREATED = 1127,
	ALERT_DELETED = 1133,
	SCHEDULED_SNAPSHOT_RECIPIENTS_CHANGED = 1135,
	SCHEDULED_SNAPSHOT_FREQUENCY_CHANGED = 1136,
	SCHEDULED_SNAPSHOT_DELETED = 1139,
	BOARD_LOOP_TEMPLATE_CREATED = 1140,
	BOARD_LOOP_TEMPLATE_DELETED = 1141,
	BOARD_PERMANENTLY_DELETED = 1142,
	BOARD_RESTORED = 1143,
	BOARD_LOOP_RESTORED = 1145,
	GOAL_PROGRESS_UPDATED = 1146,
	SMART_ALERT_CREATED = 1150,
	SMART_ALERT_DELETED = 1151,
	GENIE_SKILL_DELETED = 1254,
	GENIE_SKILL_SCOPE_CHANGED = 1255,
	GENIE_MARKETPLACE_SKILL_INSTALLED = 1256,
	GENIE_CHAT_LINK_SHARED = 1270,
	GENIE_ARTIFACT_LINK_SHARED = 1272,
	GENIE_ARTIFACT_DELETED = 1291,
	GENIE_ROUTINE_DELETED = 1312,
	GENIE_ROUTINE_WEBHOOK_CREATED = 1317,
	GENIE_ROUTINE_WEBHOOK_ROTATED = 1318,
	GENIE_CONNECTOR_CONNECTED = 1340,
	GENIE_CONNECTOR_DISCONNECTED = 1341,
	GENIE_CONNECTOR_ADDED = 1342,
	GENIE_CONNECTOR_REMOVED = 1343,
	GENIE_CONNECTOR_TOOL_PERMISSIONS_CHANGED = 1344,
	GENIE_MEMORY_DELETED = 1360,
	GENIE_MEMORIES_CLEARED = 1361,
	USER_INVITE_REJECTED = 2012,
	USER_DELETED = 2014,
	USER_PERMISSION_CHANGED = 2015,
	CLIENT_MOVED_TO_PAID_CLIENT = 2018,
	USER_PASSWORD_CHANGED = 2030,
	USER_MFA_ENABLED = 2031,
	USER_MFA_DISABLED = 2032,
	ACCOUNT_OWNER_CHANGED = 2044,
	ACCOUNT_DELETED = 2045,
	ACCOUNT_WHITE_LABELING_CHANGED = 2050,
	ACCOUNT_CLIENT_CREATED = 2080,
	ACCOUNT_CLIENT_PERMISSIONS_CHANGED = 2084,
	ACCOUNT_CLIENT_DELETED = 2086,
	SSO_ENABLED = 2100,
	FORCE_SSO_ENABLED = 2103,
	FORCE_SSO_DISABLED = 2104,
	FORCE_MFA_ENABLED = 2105,
	FORCE_MFA_DISABLED = 2106,
	USER_API_KEY_CREATED = 2107,
	USER_API_KEY_REMOVED = 2108,
	DATA_SOURCE_CREATED = 2110,
	DATA_SOURCE_REQUEST_SENT = 2111,
	DATA_SOURCE_REAUTHORIZED = 2112,
	DATA_SOURCE_PERMISSIONS_CHANGED = 2113,
	DATA_SOURCE_TIMEZONE_CHANGED = 2114,
	DATA_SOURCE_DATA_PURGED = 2115,
	DATA_SOURCE_RENAMED = 2116,
	DATA_SOURCE_DELETED = 2117,
	DATA_SOURCE_TOKEN_CREATED = 2118,
	RESELLER_SIGNUP_LINK_DISABLED = 2417,
	TRIAL_STARTED = 2500,
	TRIAL_ENDED = 2502,
	STARTED_PAYING_SUBSCRIPTION = 2503,
	BILLING_PLAN_CHANGE = 2504,
	BILLING_CYCLE_CHANGE = 2505,
	ADDON_PURCHASED = 2506,
	ADDON_REMOVED = 2507,
	PAYMENT_FAILED = 2514,
	SUBSCRIPTION_CANCEL_AT_PERIOD_END = 2515,
	AI_CREDITS_PURCHASED = 2522,
	AI_CREDITS_REMOVED = 2524,
	CLIENT_PACK_PURCHASED = 2526,
	CLIENT_PACK_REMOVED = 2528,
	USER_ROLE_CHANGED = 2602,
}

export const enum ActivityLogObjectType {
	UNDEFINED = 700,
	BOARD = 701,
	GOAL = 702,
	BOARD_TEMPLATE = 703,
	BOARD_LOOP = 704,
	REPORT = 705,
	REPORT_TEMPLATE = 706,
	CUSTOM_QUERY = 707,
	CALCULATED_METRIC = 708,
	METRIC_DIGEST = 709,
	SCORECARD = 710,
	DATA_SOURCE = 711,
	ALERT = 712,
	SCHEDULED_SNAPSHOT = 713,
	IDENTITY_PROVIDER = 714,
	COMPANY = 716,
	SPACE = 717,
	USER = 718,
	BILLING = 719,
	TEAMS = 720,
	DATASET = 721,
	GENIE_CHAT = 722,
	GENIE_ROUTINE = 723,
	GENIE_ARTIFACT = 724,
	GENIE_SKILL = 725,
	GENIE_CONNECTOR = 726,
	GENIE_MCP = 727,
	GENIE_MEMORY = 729,
}

export enum TrackingEventGroup {
	DATA_SOURCES = 902,
	CLIENTS = 903,
	USERS = 904,
	COMPANY_INFORMATION = 905,
	WHITE_LABEL = 906,
	PROFILE = 907,
	BOARDS = 908,
	BOARD_LOOPS = 909,
	METRICS = 910,
	ALERTS = 911,
	GOALS = 912,
	REPORTS = 913,
	SCHEDULED_SNAPSHOTS = 914,
	SCORECARDS = 915,
	DATA_SOURCES_PRODUCT = 920,
	BILLING = 921,
	EMAIL = 922,
}

export enum ActivityLogFeature {
	BOARDS = 1,
	LOOPS = 2,
	METRICS = 3,
	REPORTS = 4,
	DATA_SOURCES = 5,
	GOALS = 6,
	SCORECARDS = 7,
	ALERTS = 8,
	SNAPSHOTS = 9,
	PLANS_AND_BILLING = 10,
	USERS = 11,
	ACCOUNT = 12,
	COMPANY_INFORMATION = 13,
	SSO = 14,
	GENIE = 15,
}

export enum ActivityLogFetchType {
	ALL = 1,
	CLIENTS = 2,
	SPACE = 3,
}
